export class SystemDisplayManager {
    getHeaderClass() {
        return "";
    }
    shouldDisplayPortLabels() {
        return true;
    }
    getHeaderText(nodeData) {
        return nodeData.data.name;
    }
    getBackgroundColor() {
        return "rgb(44, 131, 93)";
    }
    updatePreviewContent(nodeData, contentArea) { }
}
//# sourceMappingURL=systemDisplayManager.js.map